import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PatientForm from '../../../components/PatientForm/PatientForm';
import * as actions from '../../../store/patients/actions';

function EditPatient() {
  // const connectedUser = useSelector((state) => state.auth?.user?.data);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { patient } = useSelector(state => state.patients);

   useEffect(() => {
    if (id) {
      dispatch(actions.getPatientRequest(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

 /*  if (connectedUser?.role_id !== 1) {
    return "Your are not authorized to view this page";
  } */

  return (
    <div>
        <PatientForm patient={patient} />
    </div>
  );
}

export default EditPatient;
